import {
  UAV_MESSAGE_RECEIVED,
  SET_UAV_CONNECTING,
  SET_UAV_CONNECTED,
  SET_UAV_ERROR,
  SET_CONNECTION_SETTINGS,
  SET_LATENCY,
  UAV_DNS_RECEIVED,
  SET_MISSION_DETAILS,
  DISCONNECT_UAV,
  SET_MISSION_POINTS,
  SET_PIN,
  SET_SERVER_ADDRESS,
  SET_AIRCRAFT,
  CLEAR_MISSION_POINTS,
  SET_SOCKET_STATUS,
  SET_USER_PERMISSIONS,
  CALL_COMMAND,
  SHOW_MAP,
  USE_CUBIC,
  USE_VIDEO,
  TEST_VIDEO,
  FOLLOW_DRONE,
  TEST_VIDEO_CONNECTING,
  SET_GEOFENCE,
  SHOW_FLIGHT_LOGGER,
  SET_PARSED_LOGS,
  SET_MISSION_PAUSED,
  FETCH_PREVIOUS_FLIGHTS_REQUEST,
  FETCH_PREVIOUS_FLIGHTS_SUCCESS,
  FETCH_PREVIOUS_FLIGHTS_FAILURE,
  SET_SELECTED_PREVIOUS_FLIGHT,
  UPDATE_PREVIOUS_FLIGHT_REPORT,
  SET_TELEM_STATUS,
  RESET_COMMANDS,
  SET_MISSION_ELEVATION,
  SET_DRONE_ALTITUDE_GRAPH_LINE,
  SET_PERFORMANCE_GRAPH_LINES,
  RESET_PERFORMANCE_GRAPH,
  SET_SHOW_PERFORMANCE,
  SET_REPLAY_MISSION,
  SET_FAILOVER_SOCKETS,
  SET_PILOT_INFO,
  SET_PILOT_ROLE,
  SET_VIDEO_URL
} from 'actions/actionTypes';

import { telemStates } from '../constants';


const defaultState = {
  connecting: false,
  connected: false,
  useCubic: false,
  useVideo: false,
  testVideo: false,
  followDrone: false,
  testVideoConnecting: false,
  mode: 'Web',
  serverAddress: '',
  videoUrl: false,
  pin: '',
  aircraft: false,
  pilotRole: false,
  uavDnsList: [],
  uavMessage: false,
  phone: false,
  currentMessageInSeconds: 0,
  messageInterval: 0,
  missionDetail: false,
  missionPoints: [],
  geofence: [],
  actualFlightPath: [],
  permissions: false,
  calledCommand: false,
  voltage: 0,
  latency: 0,
  socketStatus: 'CLOSED',
  rosLogs: [],
  showMap: true,
  error: false,
  showFlightLogger: false,
  previousFlights: {},
  previousFlightsKeys: [],
  fetchingPreviousFlights: false,
  selectedFlight: null,
  missionPaused: false,
  telemStatus: telemStates.OK,
  droneAltitudeGraphLine: [],
  performanceGraphLines: [],
  showPerformance: false,
  useFailoverSockets: false,
  pilotInfo: { p1: false, p2: false }
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_CONNECTION_SETTINGS: {
      return {
        ...state,
        connectionSettings: action.payload
      }
    }
    case USE_CUBIC: {
      return {
        ...state,
        useCubic: action.payload
      }
    }
    case SET_FAILOVER_SOCKETS: {
      return {
        ...state,
        useFailoverSockets: action.payload
      }
    }
    case TEST_VIDEO: {
      return {
        ...state,
        testVideo: action.payload
      }
    }
    case FOLLOW_DRONE: {
      return {
        ...state,
        followDrone: action.payload
      }
    }
    case TEST_VIDEO_CONNECTING: {
      return {
        ...state,
        testVideoConnecting: action.payload
      }
    }
    case USE_VIDEO: {
      return {
        ...state,
        useVideo: action.payload
      }
    }
    case SET_SERVER_ADDRESS: {
      return {
        ...state,
        serverAddress: action.payload,
      }
    }
    case SET_VIDEO_URL: {
      return {
        ...state,
        videoUrl: action.payload
      }
    }
    case SET_AIRCRAFT: {
      return {
        ...state,
        aircraft: action.payload
      }
    }
    case SET_PILOT_ROLE: {
      return {
        ...state,
        pilotRole: action.payload
      }
    }
    case SET_PIN: {
      return {
        ...state,
        pin: action.payload
      }
    }
    case SET_UAV_CONNECTING: {
      return {
        ...state,
        connecting: true
      }
    }
    case SET_UAV_CONNECTED: {
      return {
        ...state,
        connecting: false,
        connected: action.payload,
      }
    }
    case UAV_MESSAGE_RECEIVED: {
      return {
        ...state,
        connecting: false,
        connected: true,
        error: false,
        uavMessage: action.payload.uavMessage,
        currentMessageInSeconds: action.payload.currentMessageInSeconds,
        messageInterval: action.payload.messageInterval,
        actualFlightPath: action.payload.actualFlightPath,
        voltage: action.payload.uavMessage.battery_volts,
        phone: action.payload.phone
      };
    }
    case SET_PILOT_INFO:{
      return {
        ...state,
        pilotInfo: action.payload
      }
    }
    case SET_MISSION_DETAILS: {
      return {
        ...state,
        missionDetail: action.payload
      }
    }
    case SET_GEOFENCE: {
      return {
        ...state,
        geofence: action.payload
      }
    }
    case SET_MISSION_POINTS: {
      return {
        ...state,
        missionPoints: action.payload,
      }
    }
    case CLEAR_MISSION_POINTS: {
      return {
        ...state,
        missionPoints: false,
        actualFlightPath: [],
        missionElevation: false,
        droneAltitudeGraphLine: []
      }
    }
    case SET_DRONE_ALTITUDE_GRAPH_LINE: {
      return {
        ...state,
        droneAltitudeGraphLine: action.payload
      }
    }
    case SET_PERFORMANCE_GRAPH_LINES: {
      return {
        ...state,
        performanceGraphLines: action.payload
      }
    }
    case SET_SHOW_PERFORMANCE: {
      return {
        ...state,
        showPerformance: action.payload
      }
    }
    case SET_MISSION_ELEVATION:{
      return {
        ...state,
        missionElevation: action.payload,
      }
    }
    case RESET_PERFORMANCE_GRAPH:{
      return {
        ...state,
        performanceGraphLines: []
      }
    }
    case SHOW_MAP: {
      return {
        ...state,
        showMap: action.payload
      }
    }
    case UAV_DNS_RECEIVED: {
      return {
        ...state,
        uavDnsList: action.payload
      }
    }
    case CALL_COMMAND: {
      return {
        ...state,
        calledCommand: action.payload
      }
    }
    case SET_LATENCY: {
      return {
        ...state,
        latency: action.payload
      }
    }
    case SET_SOCKET_STATUS: {
      return {
        ...state,
        socketStatus: action.payload
      }
    }
    case SET_USER_PERMISSIONS: {
      return {
        ...state,
        permissions: action.payload
      }
    }
    case SET_UAV_ERROR: {
      return {
        ...state,
        error: action.payload
      }
    }
    case DISCONNECT_UAV: {
      return {
        ...state,
        connecting: false,
        connected: false,
        error: false,
        currentMessageInSeconds: 0,
        uavMessage: false,
        messageInterval: 0,
        missionDetail: false,
        missionPoints: [],
        geofence: [],
        actualFlightPath: [],
        permissions: false,
        calledCommand: false,
        voltage: 0,
        latency: 0,
        socketStatus: 'CLOSED',
        rosLogs: [],
        showMap: true,
        missionPaused: false,
        missionElevation: false,
        droneAltitudeGraphLine: [],
        pilotInfo: { p1: false, p2: false }
      }
    }
    case SHOW_FLIGHT_LOGGER: {
      return {
        ...state,
        showFlightLogger: action.payload
      }
    }
    case SET_PARSED_LOGS: {
      return {
        ...state,
        rosLogs: action.payload,
      }
    }
    case SET_MISSION_PAUSED: {
      return {
        ...state,
        missionPaused: action.payload
      }
    }
    case FETCH_PREVIOUS_FLIGHTS_REQUEST: {
      return {
        ...state,
        fetchingPreviousFlights: true
      }
    }
    case FETCH_PREVIOUS_FLIGHTS_SUCCESS: {
      return {
        ...state,
        previousFlights: action.payload.previousFlights,
        previousFlightsKeys: action.payload.previousFlightsKeys,
        selectedFlight: action.payload.selectedFlight,
        fetchingPreviousFlights: false
      }
    }
    case FETCH_PREVIOUS_FLIGHTS_FAILURE: {
      return {
        ...state,
        fetchingPreviousFlights: false
      }
    }
    case SET_SELECTED_PREVIOUS_FLIGHT: {
      return {
        ...state,
        selectedFlight: action.payload,
      }
    }
    case UPDATE_PREVIOUS_FLIGHT_REPORT: {
      return {
        ...state,
        previousFlights: { ...state.previousFlights, [action.payload.logId]: action.payload.updatedFlight }
      }
    }
    case SET_TELEM_STATUS: {
      return {
        ...state,
        telemStatus: action.payload
      }
    }
    case RESET_COMMANDS: {
      return {
        ...state,
        missionPaused: false,
        calledCommand: false
      }
    }
    case SET_REPLAY_MISSION: {
      return {
        ...state,
        replayMission: action.payload.replayMission,
        replayMissionStartingStep: action.payload.replayMissionStartingStep
      }
    }
    default:
      return state;
  }
};
